import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';

import { Subject } from 'rxjs';
import { map, filter, take, takeUntil } from 'rxjs/operators';

import { AppState, Selectors } from 'store/root-reducer';

import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';
import { BillableItem } from 'modules/shared/models/billable.models';

@Component({
  selector: 'artemis-engines-option',
  templateUrl: './engines-option.component.html',
  styleUrls: ['./engines-option.component.scss']
})
export class EnginesOptionComponent implements OnInit {

  private unsubscribe$: Subject<void> = new Subject();

  searchEngines: Array<BillableItem>;
  isLoading: boolean = false;

  @Output() selectedEngines: EventEmitter<string> = new EventEmitter();

  constructor(
    private cdf: ChangeDetectorRef,
    private store: Store<AppState>,
  ) {
  }

  ngOnInit() {
    this.initEngines();
  }

  private initEngines(): void {
    this.isLoading = true;
    this.store
      .select(Selectors.billable.getSearchEngines)
      .pipe(
        filter((searchEngines: Array<BillableItem>) => !!searchEngines && !!searchEngines.length),
        take(1),
        map((searchEngines: Array<BillableItem>) => searchEngines.filter((searchEngine: BillableItem) => searchEngine.display)),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (searchEngines: Array<BillableItem>) => {
          this.isLoading = false;
          this.searchEngines = searchEngines.map((searchEngine: BillableItem) => {
            const searchEngineObject: BillableItem = Object.assign({} , searchEngine);
            // Set default seletect for Atermiscan and internet search v2
            if ((searchEngineObject.serviceType === SearchEngineTypeValue.OWN_NAME) ||
            (searchEngineObject.serviceType === SearchEngineTypeValue.ARTEMISCAN)) {
              searchEngineObject['isChecked'] = true;
            }

            return searchEngineObject;
          });

          this.emitSelectedEngines();
          this.cdf.detectChanges();
        }
      );
  }

  private emitSelectedEngines(): void {
    const engines = this.searchEngines.filter((searchEngine: BillableItem) => searchEngine['isChecked'])
                                      .map((searchEngine: BillableItem) => searchEngine.serviceType)
                                      .join(',');
    this.selectedEngines.emit(engines);
  }

  onSearchEngineChanged(engine: any): void {
    if (!engine) {
      return ;
    }

    const idx: number = this.searchEngines.findIndex((searchEngine: BillableItem) => searchEngine.serviceType === engine.source.name);

    if (~idx) {
      this.searchEngines[idx]['isChecked'] = engine.checked;
      this.emitSelectedEngines();
    }
  }
}
